import React from 'react';

const ViewDetailVaccination = ({ vaccination }) => {
  // If no vaccination, show a placeholder
  if (!vaccination) return <div className="alert alert-info">No vaccination selected</div>;

  return (
    <div className="container-fluid p-0">
      <div className="row align-items-center mb-3">
        <div className="col">
          <h3>Vaccination Details</h3>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label fw-bold">Vaccination ID</label>
          <input 
            type="text" 
            className="form-control" 
            value={vaccination.id || 'N/A'} 
            readOnly 
          />
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label fw-bold">Status</label>
          <input 
            type="text" 
            className="form-control" 
            value={vaccination.status || 'N/A'} 
            readOnly
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label fw-bold">Vaccine ID</label>
          <div className="input-group mb-3">
            <input 
              type="text" 
              className="form-control" 
              value={vaccination.vaccineId || 'N/A'} 
              readOnly
            />
          </div>
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label fw-bold">Vaccine Name</label>
          <div className="input-group mb-3">
            <input 
              type="text" 
              className="form-control" 
              value={vaccination.vaccineName || 'N/A'} 
              readOnly
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label fw-bold">Patient ID</label>
          <div className="input-group mb-3">
            <input 
              type="text" 
              className="form-control" 
              value={vaccination.patientId || 'N/A'} 
              readOnly
            />
          </div>
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label fw-bold">Administrator ID</label>
          <div className="input-group mb-3">
            <input 
              type="text" 
              className="form-control" 
              value={vaccination.administratorId || 'N/A'} 
              readOnly
            />
          </div>
        </div>
      </div>

      <div className="mb-3">
        <h4>Date Information</h4>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Date Administered</label>
            <input 
              type="text" 
              className="form-control" 
              value={vaccination.dateAdministered || 'N/A'} 
              readOnly
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Next Due Date</label>
            <input 
              type="text" 
              className="form-control" 
              value={vaccination.nextDueDate || 'N/A'} 
              readOnly
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Expiration Date</label>
            <input 
              type="text" 
              className="form-control" 
              value={vaccination.expirationDate || 'N/A'} 
              readOnly
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Dose Number</label>
            <input 
              type="text" 
              className="form-control" 
              value={vaccination.doseNumber || 'N/A'} 
              readOnly
            />
          </div>
        </div>
      </div>

      <div className="mb-3">
        <h4>Administration Details</h4>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Administration Route</label>
            <input 
              type="text" 
              className="form-control" 
              value={vaccination.administrationRoute || 'N/A'} 
              readOnly
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Administration Site</label>
            <input 
              type="text" 
              className="form-control" 
              value={vaccination.administrationSite || 'N/A'} 
              readOnly
            />
          </div>
        </div>
      </div>

      <div className="mb-3">
        <h4>Product Information</h4>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Lot Number</label>
            <input 
              type="text" 
              className="form-control" 
              value={vaccination.lotNumber || 'N/A'} 
              readOnly
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Manufacturer ID</label>
            <input 
              type="text" 
              className="form-control" 
              value={vaccination.manufacturerId || 'N/A'} 
              readOnly
            />
          </div>
        </div>
      </div>

      <div className="mb-3">
        <h4>Notes</h4>
        <div className="input-group mb-3">
          <textarea
            className="form-control"
            rows="3"
            value={vaccination.notes || 'No notes recorded'}
            readOnly
          ></textarea>
        </div>
      </div>

      <div className="row">
        <div className="col-md-4 mb-3">
          <label className="form-label fw-bold">Vaccination ID (Internal)</label>
          <div className="input-group mb-3">
            <input 
              type="text" 
              className="form-control" 
              value={vaccination.vaccinationId || 'N/A'} 
              readOnly
            />
          </div>
        </div>
        <div className="col-md-4 mb-3">
          <label className="form-label fw-bold">Active Status</label>
          <div className="input-group mb-3">
            <input 
              type="text" 
              className="form-control" 
              value={vaccination.isActive ? 'Active' : 'Inactive'} 
              readOnly
            />
          </div>
        </div>
        <div className="col-md-4 mb-3">
          <label className="form-label fw-bold">Created Date</label>
          <div className="input-group mb-3">
            <input 
              type="text" 
              className="form-control" 
              value={vaccination.createdAt || 'N/A'} 
              readOnly
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewDetailVaccination;